/**
 * Main ConcoursCI application component.
 * Version 3.0 - Dashboard Admin with full system management.
 */
import { useState } from 'react';
import Dashboard from './components/Dashboard';
import LoginPage from './components/LoginPage';

function isTokenValid(token: string | null): boolean {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    // exp is in seconds (Unix timestamp)
    return typeof payload.exp === 'number' && payload.exp * 1000 > Date.now();
  } catch {
    return false;
  }
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    () => isTokenValid(localStorage.getItem('concoursci_token'))
  );

  const handleLogout = () => {
    localStorage.removeItem('concoursci_token');
    setIsAuthenticated(false);
  };

  if (!isAuthenticated) {
    return <LoginPage onLogin={() => setIsAuthenticated(true)} />;
  }

  return <Dashboard onLogout={handleLogout} />;
}

export default App;
